import { render, staticRenderFns } from "./reportStep2.vue?vue&type=template&id=1953bdda&scoped=true&"
import script from "./reportStep2.vue?vue&type=script&lang=js&"
export * from "./reportStep2.vue?vue&type=script&lang=js&"
import style0 from "./reportStep2.vue?vue&type=style&index=0&id=1953bdda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1953bdda",
  null
  
)

export default component.exports